var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProductRecommendationsProvider',{attrs:{"selectorName":_vm.selectorName,"pageType":_vm.DY_PAGE_TYPES.product,"excludeProductId":_vm.currentSpreeProduct.id,"pageData":_vm.pageData},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var title = ref.title;
var items = ref.items;
var isLoading = ref.isLoading;
return [_c('ProductRecommendationsCards',_vm._b({},'ProductRecommendationsCards',{ title: title, items: items, isLoading: isLoading },false))]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }